var exports = {
  "kL": "xa15a2ab7--2652fe--container",
  "HU": "xa15a2ab7--2652fe--aside",
  "VN": "xa15a2ab7--2652fe--close",
};

module.exports = exports;
